import request from "@/utils/http"

export function getDeviceList() {
  return request.post("/device/getDeviceList").commonDeal()
}

export function syncSetting() {
  return request.post("/device/syncSetting")
}

export function getDataList(param) {
  return request.post("/device/getDataList", param).commonDeal()
}

export function setConfigApp(appId) {
  return request.post("/device/setConfigApp", {}, { params: { appId } })
}

export function getConfigApp() {
  return request.post("/device/getConfigApp").commonDeal()
}
